<template>
  <div class="eCAssessmentCom mainPageBg">
    <div class="dateSelectBox ashComWrap">
      <DateTypeChange
        :dateList="dateList"
        :selectType="'radio'"
        :showExport="authority"
        style="margin-left: 20px"
        @getDateData="getDateData"
      />
    </div>
    <div class="tolBox freeHeightWrap">
      <div class="comTitle">
        <h4>本期能耗一览</h4>
      </div>
      <el-descriptions style="width: 98%; margin: 0 auto" :column="5">
        <el-descriptions-item label="市电">39,232 kw·h</el-descriptions-item>
        <el-descriptions-item label="光伏">19,232 kw·h</el-descriptions-item>
        <el-descriptions-item label="用水">3,232 m³</el-descriptions-item>
        <el-descriptions-item label="用气"> 3,232 m³ </el-descriptions-item>
        <el-descriptions-item label="采暖">3,232 m³</el-descriptions-item>
        <el-descriptions-item label="蒸汽">3,232 m³</el-descriptions-item>
        <el-descriptions-item label="汽油">3,232 m³</el-descriptions-item>
        <el-descriptions-item label="无烟煤">3,232 m³</el-descriptions-item>
        <el-descriptions-item label="柴油">3,232 m³</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="dataBox">
      <div
        class="ecanalysis ashComWrap"
        v-for="(v, i) in analysisList"
        :key="i"
      >
        <div class="comTitle">
          <h4>
            {{ v.title }}
            <span v-if="v.reference">对照基准:{{ v.reference }}</span>
          </h4>
          <p>单位:{{ v.unit }}</p>
        </div>
        <div class="comContentBox centerBox">
          <div class="leftTol">
            <p>{{ v.name }}</p>
            <h5>{{ v.value }}</h5>
          </div>
          <div class="rightBox">
            <SwitchingAssetTypes :item="v" />
          </div>
        </div>
      </div>
    </div>
    <div class="costBox ashComWrap">
      <div class="comTitle">
        <h4>费用分析 <span>对照基准：2022年10月</span></h4>
        <p>单位：元</p>
      </div>
      <div class="comContentBox costContent">
        <div class="costLeft">
          <div class="titleBox">
            <el-radio-group v-model="costActive" size="small">
              <el-radio label="预计费用" border>预计费用 221,932</el-radio>
              <el-radio label="实际费用" border>实际费用 201,321 </el-radio>
            </el-radio-group>
          </div>
          <div class="contentBox">
            <SwitchingAssetTypes :item="costCharts" />
          </div>
        </div>
        <div class="costright">
          <PublicEcharts
            :id="'costLine'"
            :chartsData="costLineList"
            :type="'lightLine'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateTypeChange from "@/components/DatePicker/DateTypeChange.vue";
import SwitchingAssetTypes from "./SwitchingAssetTypes.vue";
import PublicEcharts from "@/components/PublicEcharts.vue";
export default {
  props: {
    authority: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DateTypeChange,
    SwitchingAssetTypes,
    PublicEcharts,
  },
  data() {
    return {
      dateList: [
        { label: "月", value: "MONTH" },
        { label: "年", value: "YEAR" },
      ],
      analysisList: [
        {
          title: "能耗分析",
          id: "1",
          unit: "tCO₂",
          active: "系统",
          name: "折合碳排放量",
          value: 323,
          charts: {
            name: "碳排放量",
            unit: "kw·h",
            xData: [400, 300, 200, 100, 50],
            yData: ["空调系统", "照明系统", "动力系统", "采暖系统", "其他"],
          },
        },
        {
          title: "降碳量",
          id: "2",
          unit: "tCO₂",
          reference: "2022年10月",
          active: "系统",
          name: "折合降碳量",
          value: "21t",
          charts: {
            name: "降碳量",
            unit: "kw·h",
            xData: [300, 200, -30, -50, -150],
            yData: ["空调系统", "照明系统", "动力系统", "采暖系统", "其他"],
          },
        },
      ],
      costLineList: {
        title: "费用",
        unit: "元",
        xData: ["1月", "2月", "3月", "4月", "5月", "6月"],
        dataArr: [
          { name: "预计费用", data: [130, 105, 135, 120, 175, 205] },
          { name: "实际费用", data: [105, 135, 120, 175, 205, 185] },
          { name: "基准费用", data: [135, 120, 175, 205, 185, 195] },
        ],
      },
      costCharts: {
        id: "3",
        charts: {
          name: "费用",
          unit: "元",
          xData: [3000, 2000, 1500, 1300, 1000],
          yData: ["空调系统", "照明系统", "动力系统", "采暖系统", "其他"],
        },
      },
      costActive: "预计费用",
    };
  },
  methods: {
    getDateData(data) {
      // console.log("日月年切换选择", data);
    },
    exportExcel() {},
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.eCAssessmentCom {
  overflow: auto;
  .dateSelectBox {
    width: 100%;
    height: 60px;
    @include setFlexStart;
  }
  .tolBox {
    width: 100%;
    // height: 120px;
    margin: 12px 0;
  }
  .dataBox {
    width: 100%;
    height: 400px;
    @include setFlexBetween;
    .ecanalysis {
      width: $halfWidth;
      height: 100%;
      .centerBox {
        @include setFlexCenter;
        .leftTol {
          width: 20%;
          height: 100%;
          @include setFlexColumn;
          align-items: center;
          justify-content: center;
          h5 {
            font-size: 22px;
            margin-top: 20px;
          }
        }
        .rightBox {
          width: 76%;
          height: 100%;
        }
      }
    }
  }
  .costBox {
    width: 100%;
    height: 400px;
    margin: 12px 0;
    .costContent {
      @include setFlexCenter;
      .costLeft {
        width: 40%;
        height: 100%;
        @include setFlexColumn;
        justify-content: space-between;
        .titleBox {
          width: 100%;
          height: 18%;
          @include setFlexStart;
          ::v-deep .el-radio__input {
            display: none;
          }
        }
        .contentBox {
          width: 100%;
          height: 80%;
        }
      }
      .costright {
        width: 57%;
        height: 100%;
      }
    }
  }
}
</style>
